var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookSparkPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4909 15.4909C13.1636 17.8182 12 20.6545 12 24C12 20.6545 10.8364 17.8182 8.50909 15.4909C6.18182 13.1636 3.34545 12 0 12C3.34545 12 6.18182 10.8364 8.50909 8.50909C10.8364 6.18182 12 3.34545 12 0C12 3.34545 13.1636 6.18182 15.4909 8.50909C17.8182 10.8364 20.6545 12 24 12C20.6545 12 17.8182 13.1636 15.4909 15.4909Z",
    fill: "url(#paint0_linear_7016_3972)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7016_3972",
    x1: 0,
    y1: 0,
    x2: 25.4534,
    y2: 22.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4170F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6B85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSparkPurpleIcon);
export default __webpack_public_path__ + "static/media/book_spark_purple_icon.3ad68ae3e55b9e93971c514f13a4894a.svg";
export { ForwardRef as ReactComponent };